import baseApiProd from "@/api/baseprod";
import baseApiHom from "@/api/basehom";
import fields from "@/api/fields";
import order from "@/utils/order";

const refreshAuthProd = auth => baseApiProd.refreshToken(auth);
const refreshAuthHom = auth => baseApiHom.refreshToken(auth);

const getLocalDateTime = () => {
  const myDate = new Date().toLocaleString();

  const date = myDate.split(" ")[0];
  const time = myDate.split(" ")[1];

  const day = date.split("/")[0];
  const month = date.split("/")[1];
  const year = date.split("/")[2];

  const result = `${year}-${month}-${day}T${time}.000Z`;
  return result;
};

const ordenarPorVersao = lista => {
  return lista.sort((a, b) => {
    const versaoA = a.versao.split(".").map(Number);
    const versaoB = b.versao.split(".").map(Number);

    for (let i = 0; i < Math.max(versaoA.length, versaoB.length); i++) {
      const numA = versaoA[i] || 0;
      const numB = versaoB[i] || 0;

      if (numA > numB) return -1; // Mais atual
      if (numA < numB) return 1; // Mais antiga
    }

    return 0; // Se todas as partes forem iguais
  });
};

export const erros = {
  refreshAuthProd,
  order: { sortBy: "iderro", descending: 1 },
  fields: fields.erros,
  fieldsDetalhes: fields.errosDetalhes,
  fieldsAgrupados: fields.errosAgrupados,
  fieldsAgrupadosVersao: fields.errosAgrupadosVersao,
  orderAgrupados: { sortBy: "ocorrencias", descending: 1 },
  orderAgrupadosVersao: { sortBy: "ocorrenciasversao", descending: 1 },
  getAll: () => baseApiProd.get("erros").then(({ data }) => data),
  getAgrupados: () => baseApiProd.get("erros/agrupados").then(({ data }) => data),
  getAgrupadosVersao: versao =>
    baseApiProd.get(`erros/agrupados/${versao}`).then(({ data }) => data),
  getByHash: hash => baseApiProd.get(`erros/detalhes/${hash}`).then(({ data }) => data),
  getByVersao: versao => baseApiProd.get(`erros/${versao}`).then(({ data }) => data),
  getByCliente: cliente => baseApiProd.get(`erros/cliente/${cliente}`).then(({ data }) => data)
};

export const clientes = {
  refreshAuthProd,
  order: { sortBy: "idcliente", descending: 1 },
  fields: fields.clientes,
  getAll: () => baseApiProd.get("clientes").then(({ data }) => data),
  getDetalhes: cliente => baseApiProd.get(`clientes/${cliente}`).then(({ data }) => data),
  getAllAgronoticacao: () => baseApiProd.get("clientes/agronotificacao/buscar").then(({ data }) => data),

  getBeforeVersion: idversao =>
    baseApiProd.get(`clientes/beforeversion/${idversao}`).then(({ data }) => data),

  updateStatus: (cliente, body) =>
    baseApiProd.put(`clientes/${cliente}/updateStatus`, body).then(({ data }) => data),

  getMaps: () => baseApiProd.get("clientes/maps/geolocalizacao").then(({ data }) => data),

  salvarCoordenadasMapa: body =>
    baseApiProd.post("clientes/maps/geolocalizacao", body).then(({ data }) => data)
};

export const versoes = {
  refreshAuthProd,
  orderClientes: { sortBy: "data", descending: 1 },
  order: { sortBy: "idversao", descending: 1 },
  fields: fields.versoes,
  fieldsClientes: fields.versoesClientes,
  fieldsErros: fields.versoesErros,
  fieldsExecutaveis: fields.versoesExecutaveis,
  fieldsScripts: fields.versoesScripts,

  getAll: (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return baseApiProd
      .get(`versoes/detalhes${queryParams ? `?${queryParams}` : ""}`)
      .then(({ data }) => {
        return ordenarPorVersao(data);
      });
  },

  getAllComFiltros: (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return baseApiProd
      .get(`versoes/detalhes/filtros${queryParams ? `?${queryParams}` : ""}`)
      .then(({ data }) => {
        return ordenarPorVersao(data);
      });
  },

  /**
   * Busca todas as documentações existentes (otimizado)
   * @returns {Promise<Array>} Array de { versao, status, ... }
   */
  getDocumentacoes: () => baseApiProd.get("versoes/documentacoes").then(({ data }) => data),

  getDatahub: () => {
    return baseApiProd.get(`versoes/datahub`).then(({ data }) => data);
  },
  getDetalhes: versao => baseApiProd.get(`versoes/${versao}`).then(({ data }) => data),
  getScripts: versao => baseApiProd.get(`versoes/scripts/${versao}`).then(({ data }) => data),
  getExecutaveis: versao =>
    baseApiProd.get(`versoes/executaveis/${versao}`).then(({ data }) => data),
  getDisponiveis: () => baseApiProd.get("versoes/att/disponiveis").then(({ data }) => data),

  alterarDisponibilidade: (versao, body) =>
    baseApiProd.put(`versoes/${versao}/disponibilidade`, body).then(({ data }) => data),

  getExecutaveisExternal: () => baseApiProd.get(`versoes/external`).then(({ data }) => data),

  getExecutaveisExternalVersao: versao =>
    baseApiProd.get(`versoes/external/${versao}`).then(({ data }) => data),

  // Documentação
  getDocumentacao: versao =>
    baseApiProd.get(`versoes/${versao}/documentacao`).then(({ data }) => data),

  criarDocumentacao: (versao, body) =>
    baseApiProd.post(`versoes/${versao}/documentacao`, body).then(({ data }) => data),

  atualizarDocumentacao: (versao, body) =>
    baseApiProd.put(`versoes/${versao}/documentacao`, body).then(({ data }) => data),

  finalizarDocumentacao: versao =>
    baseApiProd.put(`versoes/${versao}/documentacao/finalizar`).then(({ data }) => data),

  liberarDocumentacao: versao =>
    baseApiProd.put(`versoes/${versao}/documentacao/liberar`).then(({ data }) => data),

  excluirDocumentacao: versao =>
    baseApiProd.delete(`versoes/${versao}/documentacao`).then(({ data }) => data),

  gerarDocumentacaoRedmine: versao =>
    baseApiProd.post("documentacao/redmine", { versao }).then(({ data }) => data),

  converterHTMLParaRedmine: html =>
    baseApiProd.post("documentacao/html-para-redmine", { html }).then(({ data }) => data.texto)
};

export const dashboard = {
  refreshAuthProd,
  get: () => baseApiProd.get("dashboard").then(({ data }) => data),
  getEmpresasDetalhes: (processo, descricao) =>
    baseApiProd
      .get(`dashboard/${processo}?descricao=${encodeURIComponent(descricao)}`)
      .then(({ data }) => data)
};

export const authProd = {
  refreshAuthProd,
  login: async data => await baseApiProd.post("auth/login", data).then(({ data }) => data)
};

export const authHom = {
  refreshAuthHom,
  login: async data => await baseApiHom.post("auth/login", data).then(({ data }) => data)
};

export const auditoria = {
  prod: {
    refreshAuthProd,
    getAll: async (params = {}) => {
      const queryParams = new URLSearchParams(params).toString();
      const link = `versoes/detalhes${queryParams ? `?${queryParams}` : ""}`;

      return await baseApiProd.get(link).then(({ data }) => data);
    },
    getScripts: () => baseApiProd.get("versoes/scripts/0").then(({ data }) => data),
    getExecutaveis: () => baseApiProd.get("versoes/executaveis/0").then(({ data }) => data)
  },
  hom: {
    refreshAuthHom,
    getAll: async (params = {}) => {
      const queryParams = new URLSearchParams(params).toString();
      const link = `versoes/detalhes${queryParams ? `?${queryParams}` : ""}`;
      return await baseApiHom.get(link).then(({ data }) => data);
    },
    getScripts: () => baseApiHom.get("versoes/scripts/0").then(({ data }) => data),
    getExecutaveis: () => baseApiHom.get("versoes/executaveis/0").then(({ data }) => data)
  }
};

export const versaoAgendamento = {
  refreshAuthProd,
  order: { sortBy: "executado", descending: false },
  fields: fields.versaoAgendamento,
  footerButtons: [
    {
      color: "primary",
      icon: "add",
      text: "Incluir",
      to: "/atualizacao/cadastro"
    }
  ],

  getAll: () => baseApiProd.get(`versaoagendamento`).then(({ data }) => data),
  create: registers => {
    registers.createdAt = getLocalDateTime();
    return baseApiProd.post("versaoagendamento", registers).then(({ data }) => data);
  },
  cancelar: (id, motivo) => {
    const data = { updatedAt: getLocalDateTime(), motivo };
    return baseApiProd.post(`versaoagendamento/${id}/cancelar`, data).then(({ data }) => data);
  },
};

export const versaoAgendamentoSubstituicao = {
  refreshAuthProd,
  getClientes: (idversao, softhouse) =>
    baseApiProd
      .get(`clientes/byversion/${idversao}?softhouse=${softhouse}`)
      .then(({ data }) => data),
  getExecutaveis: versao =>
    baseApiProd.get(`versoes/agendamento/${versao}`).then(({ data }) => data),
  getAll: (datade, dataate) =>
    baseApiProd
      .get(`versaoagendamentosubstituicao?dataDe=${datade}&dataAte=${dataate}`)
      .then(({ data }) => data),
  getVersionBefore: (version, onlyProduction) =>
    baseApiProd
      .get(`versoes/filtro/superior?versao=${version}&onlyproduction=${onlyProduction}`)
      .then(({ data }) => data),
  getLogs: idagendamento =>
    baseApiProd.get(`versaoagendamentosubstituicao/${idagendamento}/logs`).then(({ data }) => data),
  create: data => {
    return baseApiProd.post(`versaoagendamentosubstituicao`, data).then(({ data }) => data);
  },
  cancel: (idagendamento, motivo) => {
    const nowWithoutTimezoneForMySQL = () => {
      const d = new Date();

      const pad = n => String(n).padStart(2, "0");

      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    };

    return baseApiProd
      .post(`versaoagendamentosubstituicao/${idagendamento}/cancelar`, {
        motivo,
        datahora: nowWithoutTimezoneForMySQL()
      })
      .then(({ data }) => data);
  }
};

export const versaoLog = {
  refreshAuthProd,
  getByAgendamento: versaoagendamento =>
    baseApiProd.get(`versaolog/${versaoagendamento}`).then(({ data }) => data)
};

export const integracao = {
  refreshAuthProd,

  getByTerceiro: () => baseApiProd.get(`integracao/lar/terceiro`).then(({ data }) => data),

  createTerceiro: body =>
    baseApiProd.post(`integracao/lar/terceiro`, body).then(({ data }) => data),

  updateTerceiro: terceiro =>
    baseApiProd.put(`integracao/lar/terceiro/${terceiro.id}`, terceiro).then(({ data }) => data),

  getBySyncCliente: cliente =>
    baseApiProd.get(`integracao/lar/sync_cliente/${cliente}`).then(({ data }) => data),

  getByCliente: () => baseApiProd.get(`integracao/lar/cliente`).then(({ data }) => data),

  getByTerceiroCliente: () =>
    baseApiProd.get(`integracao/lar/terceirocliente`).then(({ data }) => data),

  createTerceiroCliente: body =>
    baseApiProd.post(`integracao/lar/terceirocliente`, body).then(({ data }) => data),

  updateTerceiroClienteStatus: body => baseApiProd.put(`integracao/lar/terceirocliente`, body),

  getBySistemaCliente: () =>
    baseApiProd.get(`integracao/pesador/sistemacliente`).then(({ data }) => data),

  createSistemaCliente: body =>
    baseApiProd.post(`integracao/pesador/sistemacliente`, body).then(({ data }) => data),

  getBySistema: () => baseApiProd.get(`integracao/pesador/sistema`).then(({ data }) => data),

  getBySincronia: () => baseApiProd.get(`integracao/pesador/sincronia`).then(({ data }) => data),

  getSincroniaData: (tabela, hash) =>
    baseApiProd.get(`integracao/pesador/sincronia/${tabela}/${hash}`).then(({ data }) => data),

  getBySincroniaTerceiroCliente: () =>
    baseApiProd.get(`integracao/lar/sincroniaterceirocliente`).then(({ data }) => data),

  getTerceiroClienteData: (hash, tabela) =>
    baseApiProd.get(`integracao/lar/${hash}/${tabela}`).then(({ data }) => data),

  getByRomcliorigemdestino: () =>
    baseApiProd.get(`integracao/romcliorigemdestino`).then(({ data }) => data),

  getByVwClientes: () =>
    baseApiProd.get(`integracao/romcliorigemdestino/vwclientes`).then(({ data }) => data),

  getByRomcliorigemdestinoData: (idcliente, idOrigemDestino) =>
    baseApiProd
      .get(`integracao/romcliorigemdestino/${idcliente}/${idOrigemDestino}/empresas`)
      .then(({ data }) => data),

  updateRomcliOrigemDestino: (id, body) =>
    baseApiProd.put(`integracao/romcliorigemdestino/${id}`, body).then(({ data }) => data),

  getSincroniaRomcliOrigemDestinoData: (
    hashOrigem,
    hashDestino,
    cnpjCpfOrigem,
    cnpjCpfDestino,
    cceDestino,
    tabela
  ) =>
    baseApiProd
      .get(
        `integracao/romcliorigemdestino/sincronia/${hashOrigem}/${hashDestino}/${cnpjCpfOrigem}/${cnpjCpfDestino}/${cceDestino}/${tabela}`
      )
      .then(({ data }) => data),

  getClientesDuplicados: empresaorigem =>
    baseApiProd
      .get(`integracao/romcliorigemdestino/clientesduplicados/${empresaorigem}`)
      .then(({ data }) => data),

  getDashboardRomaneiosClientes: (dtInicial, dtFinal) =>
    baseApiProd.get(`romaneiosentreclientes?dtInicial=${dtInicial}&dtFinal=${dtFinal}`).then(({ data }) => data)
};

export const server = {
  refreshAuthProd,
  getClientes: () => baseApiProd.get("server/logs/clientes").then(({ data }) => data),

  getLogs: (hash, query) => {
    let url = "";

    if (query) {
      url += "?";

      for (const item in query) {
        if (!url.endsWith("?")) {
          url += "&";
        }

        url += `${item}=${query[item]}`;
      }
    }

    return baseApiProd.get(`server/${hash}/logs${url}`).then(({ data }) => data);
  },
  getStatus: (hash, query) => {
    let url = "";

    if (query) {
      url += "?";

      for (const item in query) {
        if (!url.endsWith("?")) {
          url += "&";
        }

        url += `${item}=${query[item]}`;
      }
    }

    return baseApiProd.get(`server/status${url}`).then(({ data }) => data);
  }
};

export default {
  fields,
  refreshAuthProd,
  refreshAuthHom,
  authProd,
  authHom,
  auditoria,
  erros,
  clientes,
  versoes,
  versaoAgendamento,
  versaoAgendamentoSubstituicao,
  integracao,
  server,
  dashboard
};
